import domReady from '@wordpress/dom-ready';
import { CountUp } from 'countup.js/dist/countUp';
domReady(() => {
  const counters = document.querySelectorAll('.is-style-item-stats strong');

  if (0 < counters.length) {
    counters.forEach((counter) => {
      const number = parseInt(counter.textContent);
      const lang = document.documentElement.getAttribute('lang') || '';
      const isFrench = lang.startsWith('fr');
      const animation = new CountUp(counter, number, {
        duration: 2,
        separator: isFrench ? ' ' : ',',
        enableScrollSpy: true,
        scrollSpyDelay: 300,
      });

      animation.handleScroll();
    });
  }
});
